import { render, staticRenderFns } from "./hunterPost.vue?vue&type=template&id=2b57accf&scoped=true"
import script from "./hunterPost.vue?vue&type=script&lang=js"
export * from "./hunterPost.vue?vue&type=script&lang=js"
import style0 from "./hunterPost.vue?vue&type=style&index=0&id=2b57accf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b57accf",
  null
  
)

export default component.exports